import React, { useState } from 'react';
import axios from 'axios';
import { API_BASE } from '../../config/api';
import './RefundForm.css';

const RefundForm = ({ order, onClose, onSuccess }) => {
  const [formData, setFormData] = useState({
    accountNumber: '',
    ifscCode: '',
    accountHolderName: '',
    refundReason: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await axios.post(`${API_BASE}/refund/request`, {
        orderId: order._id,
        bankDetails: {
          accountNumber: formData.accountNumber,
          ifscCode: formData.ifscCode,
          accountHolderName: formData.accountHolderName
        },
        refundReason: formData.refundReason
      }, { withCredentials: true });

      if (response.data.message) {
        onSuccess(response.data.message);
        onClose();
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to submit refund request');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="refund-form-overlay">
      <div className="refund-form-modal">
        <div className="refund-form-header">
          <h2>Request Refund</h2>
          <button className="close-btn" onClick={onClose}>&times;</button>
        </div>

        <div className="refund-form-content">
          <div className="order-summary">
            <h3>Order Details</h3>
            <p><strong>Order ID:</strong> #{order._id.slice(-8)}</p>
            <p><strong>Amount:</strong> ₹{order.totalPrice.toFixed(2)}</p>
            <p><strong>Payment Method:</strong> {order.paymentMethod}</p>
          </div>

          {error && <div className="error-message">{error}</div>}

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="accountHolderName">Account Holder Name *</label>
              <input
                type="text"
                id="accountHolderName"
                name="accountHolderName"
                value={formData.accountHolderName}
                onChange={handleChange}
                required
                placeholder="Enter account holder name"
              />
            </div>

            <div className="form-group">
              <label htmlFor="accountNumber">Account Number *</label>
              <input
                type="text"
                id="accountNumber"
                name="accountNumber"
                value={formData.accountNumber}
                onChange={handleChange}
                required
                placeholder="Enter account number"
                pattern="[0-9]{9,18}"
                title="Please enter a valid account number (9-18 digits)"
              />
            </div>

            <div className="form-group">
              <label htmlFor="ifscCode">IFSC Code *</label>
              <input
                type="text"
                id="ifscCode"
                name="ifscCode"
                value={formData.ifscCode}
                onChange={handleChange}
                required
                placeholder="Enter IFSC code"
                style={{ textTransform: 'uppercase' }}
              />
            </div>

            <div className="form-group">
              <label htmlFor="refundReason">Refund Reason *</label>
              <textarea
                id="refundReason"
                name="refundReason"
                value={formData.refundReason}
                onChange={handleChange}
                required
                placeholder="Please provide a reason for the refund request"
                rows="3"
              />
            </div>

            <div className="form-actions">
              <button 
                type="button" 
                className="cancel-btn" 
                onClick={onClose}
                disabled={loading}
              >
                Cancel
              </button>
              <button 
                type="submit" 
                className="submit-btn"
                disabled={loading}
              >
                {loading ? 'Submitting...' : 'Submit Refund Request'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default RefundForm; 